import React from 'react';
import {NavLink, useLocation} from "react-router-dom";
import {RUOLI} from "../../../../applicationConf";

import cx from 'classnames';
import headerModuleStyle from '../css/Header.module.css';


const SuperAdmin = ({ruoloScelto, userCf}) => {

    const dropdownMenuLink = React.useRef();
    const dropdownMenu = React.useRef();

    const {pathname} = useLocation();

    const SUPER_ADMIN_CONFIG = (ruoloScelto && RUOLI[ruoloScelto.toUpperCase()].SUPER_ADMIN)
        ? RUOLI[ruoloScelto.toUpperCase()].SUPER_ADMIN
        : RUOLI.SYSTEMADMIN.SUPER_ADMIN;

    // Alcune voci (es. Editor Database) sono ristrette a specifici utenti (per codice fiscale)
    // indipendentemente dal ruolo: la vera sicurezza è comunque lato server, questo filtro
    // serve solo a non mostrare in menu una voce che l'utente non potrebbe comunque usare.
    const CONFIGURATION_RUOLO = SUPER_ADMIN_CONFIG.LINKS
        .filter(link => !link.RESTRICTED_TO_CF || link.RESTRICTED_TO_CF.includes((userCf || '').toUpperCase()));

    const closeDropdownMenu = (e) => {
        if (dropdownMenu.current != null && dropdownMenu.current.classList.contains(headerModuleStyle['show']) &&
            !dropdownMenu.current.contains(e.target) && !dropdownMenuLink.current.contains(e.target)) {

            dropdownMenu.current.classList.remove(headerModuleStyle['show']);

            window.removeEventListener('click', closeDropdownMenu, false);
        }
    }

    const openDropdownMenu = () => {
        dropdownMenu.current.classList.toggle(headerModuleStyle['show']);

        if (dropdownMenu.current.classList.contains(headerModuleStyle['show'])) {

            window.addEventListener('click', closeDropdownMenu, false);

        } else if (!dropdownMenu.current.classList.contains(headerModuleStyle['show'])) {

            window.removeEventListener('click', closeDropdownMenu, false);

        }
    }

    return (
        <li className={cx('nav-item', 'dropdown')}
            ref={dropdownMenuLink}
            onClick={openDropdownMenu}
            style={{cursor: 'pointer', color: 'rgba(0, 0, 0, 0.5)'}}>

            <span
                className={cx('nav-link', 'dropdown-toggle', {active: pathname.startsWith(SUPER_ADMIN_CONFIG.CONTEXT_ROUTES)})}>
                Super Admin
            </span>
            <div className={cx('dropdown-menu')} ref={dropdownMenu}>

                {CONFIGURATION_RUOLO.map((link, index) => (
                    <NavLink to={`${SUPER_ADMIN_CONFIG.CONTEXT_ROUTES}${link.LINK}`}
                             key={`${link.LINK.split('/')[1]}#${index}`}
                             className={navData => navData.isActive ? cx('nav-link', 'active') : cx('nav-link')}
                             style={{cursor: 'pointer'}} end>
                        {link.DISPLAY_VALUE}
                    </NavLink>
                ))}

            </div>
        </li>
    )
}

export default SuperAdmin;




